import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  preview_fallback: {
    height: "100%",
    width: "100%",
  },
  preview_image: {
    borderRadius: spacing(0.5),
    height: "100%",
    objectFit: "contain",
    width: "100%",
  },
  wrapper: {
    [breakpoints.down("sm")]: {
      maxHeight: "45vh",
    },

    alignItems: "center",
    aspectRatio: "1/1",
    backgroundColor: palette.primary.light,
    display: "flex",
    justifyContent: "center",
    padding: spacing(2),
    width: "100%",
  },
}));
